module.exports = __webpack_public_path__ + "static/media/background-card-style.8664d4af.png";